// SubscriptionContent Component

import classnames from 'classnames'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import querystring from 'querystring'

import AppContext from '../../../app-context'
import app from '../../../app.jsx'
import { Button, Icon } from '@rodeo-dev/legos'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import currency from '../../../lib/currency.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import SubscriptionUtil from '../../../lib/subscriptionutil.jsx'
import Util from '../../../lib/util.jsx'

import PaymentButtons from './PaymentButtons.jsx'
import SubscriptionAddon from './SubscriptionAddon.jsx'

class SubscriptionContent extends Component {
  static contextType = AppContext

  static get propTypes () {
    return {
      user: PropTypes.object,
      team: PropTypes.object,
      subscriptionUpcoming: PropTypes.object,
      issuers: PropTypes.array,
      isTeamUSA: PropTypes.bool,
      isTrail: PropTypes.bool,
      hideAddonSettings: PropTypes.bool,
      hideHeaderStat: PropTypes.bool,
      showUpgrade: PropTypes.bool,
      upgradeTitle: PropTypes.string,
      onPayment: PropTypes.func,
      onActivatePlanner: PropTypes.func,
      onActivateInternalExpenses: PropTypes.func,
      onError: PropTypes.func,
      onCancelAccount: PropTypes.func,
      histories: PropTypes.array,
      onClickDownload: PropTypes.func,
      onQuickbookPayment: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      user: null,
      team: null,
      subscriptionUpcoming: null,
      issuers: null,
      isTeamUSA: false,
      isTrail: false,
      hideAddonSettings: false,
      hideHeaderStat: false,
      showUpgrade: false,
      upgradeTitle: '',
      onPayment: null,
      onActivatePlanner: null,
      onActivateInternalExpenses: null,
      onError: null,
      onCancelAccount: null,
      histories: [],
      onClickDownload: null,
      onQuickbookPayment: null
    }
  }

  constructor (props, context) {
    super(props, context)

    this.data = {
      team: props.team,
      subscriptionUpcoming: props.subscriptionUpcoming,
      bank: props.issuers ? props.issuers : [],
      histories: props.histories ? props.histories : [],
      startEmpty: false
    }

    const queryParams = querystring.parse(window.location.href.split('?')[1])
    const shouldReactivate = Boolean(queryParams.reactivate)

    const status = props.team.subscription.status
      ? props.team.subscription.status
      : 'trail'
    const isExpired = props.team.subscription.isExpired

    const isTrialAndActive = status === 'trail' && this.hasPaymentSetup()
    const isTrialWithoutPayment = status === 'trail' && !this.hasPaymentSetup()

    const bShowUpgrade =
      shouldReactivate ||
      (status === 'active' && !isExpired) ||
      isTrialAndActive ||
      props.showUpgrade
    const bShowPayment =
      shouldReactivate || status === 'cancelled' || isTrialWithoutPayment
    const bShowTrail =
      (isTrialWithoutPayment || isExpired || status === 'cancelled') &&
      !bShowUpgrade

    this.state = {
      bank: '',
      bShowUpgrade,
      bShowPayment,
      bShowTrail,
      showUpgradeDialog: false
    }

    this._hidePaymentSubmit = false
    this._references = {
      dialogUpgrade: React.createRef()
    }
  }

  hasPaymentSetup = () =>
    Boolean((this.data.team.subscription.paymentInfo || []).length)

  // TODO: REFACTOR THIS ASAP
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.team && !_.isEqual(nextProps.team, this.props.team)) {
      this.data.team = nextProps.team
      this.data.subscriptionUpcoming = nextProps.subscriptionUpcoming

      const queryParams = querystring.parse(window.location.href.split('?')[1])
      const shouldReactivate = Boolean(queryParams.reactivate)

      const status = this.data.team.subscription.status
        ? this.data.team.subscription.status
        : 'trail'

      const isExpired = this.data.team.subscription.isExpired
      const isTrialAndActive = status === 'trail' && this.hasPaymentSetup()
      const isTrialWithoutPayment =
        status === 'trail' && !this.hasPaymentSetup()

      const bShowUpgrade =
        shouldReactivate ||
        (status === 'active' && !isExpired) ||
        isTrialAndActive ||
        nextProps.showUpgrade
      const bShowPayment =
        shouldReactivate || status === 'cancelled' || isTrialWithoutPayment
      const bShowTrail =
        (isTrialWithoutPayment || isExpired || status === 'cancelled') &&
        !bShowUpgrade

      this.setState({
        dataDate: new Date(),
        bShowPayment,
        bShowUpgrade,
        bShowTrail
      })
    }
  }

  render () {
    const { team } = this.data
    const {
      user,
      isTeamUSA,
      hideAddonSettings,
      hideHeaderStat,
      upgradeTitle
    } = this.props
    const { bShowTrail, bShowUpgrade, bShowPayment } = this.state

    const bShowInvoices =
      team.subscription.status !== 'trail' &&
      !!this.data.histories.length &&
      !bShowTrail

    const subscriptionUpcoming = this.data.subscriptionUpcoming
    const trailClass = classnames('trialcont', { active: bShowTrail })
    const upgradeClass = classnames('upgradecont', { active: bShowUpgrade })
    const footerClassName = `footercont${bShowUpgrade ? ' footercont_alt' : ''}`
    const statusLabel = `setting.subscription.subscription${team.subscription.status}`
    const priceIconRight = isTeamUSA
      ? 'icon icon-setting-priceusd'
      : 'icon icon-setting-priceeuro'
    const priceIconLeft = isTeamUSA
      ? 'icon icon-setting-list-usd'
      : 'icon icon-setting-listeuro'
    const priceIconMain = isTeamUSA
      ? 'icon icon-setting-subscription-usd'
      : 'icon icon-setting-subscriptioneuro'
    const isTeamPaid = team.subscription.status === 'active'
    const isCancelled = team.subscription.status === 'cancelled'
    const isTrial = team.subscription.status === 'trail'
    const useFeatureInternalExpenses = this.context.featureToggles.FEATURE_USE_INTERNAL_EXPENSES === 'true'
    const allowPlannerAddonPurchase = !isCancelled && !hideAddonSettings
    const allowInternalExpensesAddonPurchase = !isCancelled && !hideAddonSettings && !isTrial
    const isPlannerActive = team.subscription.isPlannerActive && !isCancelled
    const isInternalExpensesActive = team.subscription.isInternalExpensesActive && !isCancelled

    return (
      <div className='subscription-content'>
        <div className='headercont'>
          {!hideHeaderStat && (
            <div className='itemwrap'>
              <div className='infoitem'>
                <label className='title'>
                  <IntlMessage ident='setting.subscription.subscriptionStatus' />
                </label>
                <h2 className='value'>
                  <IntlMessage ident={statusLabel} />
                </h2>
              </div>
              <div className='infoitem'>
                <label className='title'>
                  <IntlMessage ident='setting.subscription.fullUsers' />
                </label>
                <h2 className='value'>{team.subscription.noUsersFull}</h2>
              </div>
              <div className='infoitem'>
                <label className='title'>
                  <IntlMessage ident='setting.subscription.standardUsers' />
                </label>
                <h2 className='value'>{team.subscription.noUsersStandard}</h2>
              </div>
            </div>
          )}
        </div>
        <div className='maincont'>
          <div className={trailClass}>
            <div className='inner'>
              <div className='leftcol'>
                <h1 className='title'>
                  <IntlMessage
                    ident={
                      isTeamPaid
                        ? 'setting.subscription.contentTitlePaid'
                        : 'setting.subscription.contentTitle'
                    }
                  />
                </h1>
                <p className='subtitle'>
                  <IntlMessage
                    ident={
                      isTeamPaid
                        ? 'setting.subscription.contentInfoPaid'
                        : 'setting.subscription.contentInfo'
                    }
                  />
                </p>
                {this._renderPaymentLogos()}
                <Button
                  size='medium'
                  className='upgrade'
                  onClick={() => this._onUpgradeConfirm()}
                  startIcon={<Icon color='inherit' icon='check' />}
                >
                  <IntlMessage ident='setting.subscription.actionUpgrade' />
                </Button>
              </div>
              <div className='rightcol'>
                <div className='trialinfo'>
                  <span className='info'>
                    <IntlMessage
                      ident={
                        isTeamPaid
                          ? 'setting.subscription.onEndPaidSubscription'
                          : 'setting.subscription.onEndTrial'
                      }
                    />
                  </span>
                  <h2 className='date'>
                    {DateUtil.getDisplayDate(team.subscription.endDate)}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className={upgradeClass}>
            <form method='post' action='#' className='upgradeform'>
              <div className='inner'>
                <div className='leftcol'>
                  <h1 className='title'>
                    {upgradeTitle ? (
                      <IntlMessage ident={upgradeTitle} />
                    ) : (
                      <IntlMessage ident='setting.subscription.upgradeContentTitle' />
                    )}
                  </h1>
                  <p className='subtitle'>
                    <IntlMessage ident='setting.subscription.upgradeContentInfo' />
                  </p>
                  <div className='invoicecont'>
                    <div className='head'>
                      <h2 className='title'>
                        <IntlMessage ident='setting.subscription.yourInvoice' />
                      </h2>
                    </div>
                    <div className='listinfo'>
                      <table className='listinfo__table'>
                        <tbody>
                          {this._renderUpcomingItems()}
                          {this._renderDiscounts()}
                          {/* Subtotal */}
                          <tr className='alt'>
                            <td />
                            <td>
                              <IntlMessage ident='setting.subscription.totalAmountExcl' />
                            </td>
                            <td />
                            <td>
                              <div className='price'>
                                <i className={priceIconLeft} />
                                <span className='col alt'>
                                  {currency.format(
                                    subscriptionUpcoming.totalExcl
                                  )}
                                </span>
                              </div>
                            </td>
                          </tr>
                          {/* VAT */}
                          <tr>
                            <td />
                            <td>
                              {IntlUtil.convertMessage(
                                'setting.subscription.taxLineLabel',
                                {
                                  taxPercent: subscriptionUpcoming.vatPercentage
                                }
                              )}
                            </td>
                            <td />
                            <td>
                              <div className='price'>
                                <i className={priceIconLeft} />
                                <span className='col'>
                                  {currency.format(
                                    subscriptionUpcoming.vatAmount
                                  )}
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className='totalprice'>
                      <span className='euroicon'>
                        <i className={priceIconMain} />
                      </span>
                      <h2 className='price'>
                        {currency.format(subscriptionUpcoming.total)}
                      </h2>
                      <span className='info'>
                        <IntlMessage ident='setting.subscription.totalAmount' />
                      </span>
                    </div>
                  </div>
                </div>
                <div className='rightcol'>
                  <div className='pricerow'>
                    <div className='pricecol'>
                      <i className={priceIconRight} />
                      <h2 className='price'>
                        {team.subscription.priceAdministrator}
                      </h2>
                    </div>
                    <div className='infocol'>
                      <p className='cont'>
                        <IntlMessage ident='setting.subscription.FullUser' />
                      </p>
                    </div>
                  </div>
                  <div className='pricerow'>
                    <div className='pricecol'>
                      <i className={priceIconRight} />
                      <h2 className='price'>{team.subscription.priceFull}</h2>
                    </div>
                    <div className='infocol'>
                      <p className='cont'>
                        <IntlMessage ident='setting.subscription.extraFullUser' />
                      </p>
                    </div>
                  </div>
                  <div className='pricerow'>
                    <div className='pricecol'>
                      <i className={priceIconRight} />
                      <h2 className='price'>
                        {team.subscription.priceStandard}
                      </h2>
                    </div>
                    <div className='infocol'>
                      <p className='cont'>
                        <IntlMessage ident='setting.subscription.extraStandardUserText' />
                      </p>
                    </div>
                  </div>
                  <SubscriptionAddon
                    title={IntlUtil.convertMessage('setting.subscription.planner')}
                    isTeamUSA={this.props.isTeamUSA}
                    price={currency.format(team.subscription.pricePlanner)}
                    description={IntlUtil.convertMessage('setting.subscription.plannerUserText')}
                    allowPurchase={allowPlannerAddonPurchase}
                    isTrial={isTrial}
                    isAddonActive={isPlannerActive}
                    activateButtonText={IntlUtil.convertMessage('setting.subscription.activatePlanner')}
                    deactivateButtonText={IntlUtil.convertMessage('setting.subscription.deactivatePlanner')}
                    onClick={this.props.onActivatePlanner.bind(this)}
                  />
                  {useFeatureInternalExpenses && (
                    <SubscriptionAddon
                      title={IntlUtil.convertMessage('setting.subscription.expenses')}
                      isTeamUSA={this.props.isTeamUSA}
                      price={currency.format(team.subscription.priceInternalExpenses)}
                      description={IntlUtil.convertMessage('setting.subscription.expensesUserText')}
                      allowPurchase={allowInternalExpensesAddonPurchase}
                      isAddonActive={isInternalExpensesActive}
                      activateButtonText={IntlUtil.convertMessage('setting.subscription.activateExpenses')}
                      deactivateButtonText={IntlUtil.convertMessage('setting.subscription.deactivateExpenses')}
                      onClick={this.props.onActivateInternalExpenses.bind(this)}
                      urlText={IntlUtil.convertMessage('setting.subscription.internalExpensesLink')}
                      url='https://www.getrodeo.io/product/estimates-costs/'
                    />
                  )}
                </div>
                {bShowPayment && (
                  <PaymentButtons
                    user={user}
                    team={team}
                    setTeam={teamId => app.setTeam(teamId)}
                  />
                )}
              </div>
            </form>
          </div>
          <div className={footerClassName}>
            {bShowInvoices && (
              <div className='invoicelist'>
                <div className='head'>
                  <h2 className='title'>
                    <IntlMessage ident='setting.subscription.previousInvoice' />
                  </h2>
                </div>
                <div className='listinfo'>{this._renderHistories()}</div>
              </div>
            )}
            {!isCancelled && (
              <a
                title={IntlUtil.convertMessage(
                  'setting.subscription.cancelAccountInfo'
                )}
                href='#'
                className='accountlink'
                onClick={this._onCancelAccount.bind(this)}
              >
                <i className='icon icon-setting-accountcancel normal' />
                <i className='icon icon-setting-accountcancel-hover hover' />
                <IntlMessage ident='setting.subscription.cancelAccountInfo' />
              </a>
            )}
          </div>
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onUpgradeClick (e) {
    e.preventDefault()
    this.setState({ showUpgradeDialog: true })
  }

  _onUpgradeConfirm () {
    return this.setState({
      showUpgradeDialog: false,
      bShowUpgrade: true,
      bShowTrail: false
    })
  }

  _onCancelAccount (ev) {
    ev.preventDefault()
    if (this.props.onCancelAccount) {
      this.props.onCancelAccount()
    }
  }

  _onClickDownload (historyId) {
    if (this.props.onClickDownload) {
      this.props.onClickDownload(historyId)
    }
  }

  /* Private Functions */
  _canShowIdeal (country) {
    return country !== 'US' && country !== 'DE'
  }

  _renderPaymentLogos () {
    const { team } = this.data
    const showIdeal = this._canShowIdeal(team.profile.country)

    return (
      <div className='paymentlogos'>
        {showIdeal && (
          <img
            src='/subscription/ideal.png'
            alt='Rodeo'
            className='logo'
            title={IntlUtil.convertMessage('setting.subscription.titleRodeo')}
          />
        )}
        <img
          src='/subscription/visa.png'
          alt='Rodeo'
          className='logo'
          title={IntlUtil.convertMessage('setting.subscription.titleRodeo')}
        />
        <img
          src='/subscription/mastercard.png'
          alt='Rodeo'
          className='logo'
          title={IntlUtil.convertMessage('setting.subscription.titleRodeo')}
        />
        <img
          src='/subscription/maestro.png'
          alt='Rodeo'
          className='logo'
          title={IntlUtil.convertMessage('setting.subscription.titleRodeo')}
        />
      </div>
    )
  }

  _renderUpcomingItems () {
    let items =
      this.data.subscriptionUpcoming && this.data.subscriptionUpcoming.items
        ? this.data.subscriptionUpcoming.items
        : []
    items = _.sortBy(items, 'pricePerUser')
    items.reverse()
    const priceIconLeft = this.props.isTeamUSA
      ? 'icon icon-setting-list-usd'
      : 'icon icon-setting-listeuro'

    if (items.length > 0) {
      return items.map((item, idx) => {
        const bShowItem =
          item.type === 'Planner' ? item.active : item.noUsers > 0
        if (!bShowItem) {
          return null
        }

        return (
          <tr key={idx}>
            <td>{item.noUsers}</td>
            <td>
              {SubscriptionUtil.translateItemTitle(
                item.title,
                IntlUtil.getLang()
              )}
            </td>
            <td>
              <div className='price'>
                <i className={priceIconLeft} />
                <span>{currency.format(item.pricePerUser)}</span>
              </div>
            </td>
            <td>
              <div className='price'>
                <i className={priceIconLeft} />
                <span className='alt'>{currency.format(item.total)}</span>
              </div>
            </td>
          </tr>
        )
      })
    }

    return null
  }

  _renderDiscounts () {
    const items =
      this.data.subscriptionUpcoming && this.data.subscriptionUpcoming.discounts
        ? this.data.subscriptionUpcoming.discounts
        : []
    const priceIconLeft = this.props.isTeamUSA
      ? 'icon icon-setting-list-usd'
      : 'icon icon-setting-listeuro'

    if (items.length > 0) {
      return items.map((item, idx) => {
        return (
          <tr key={idx}>
            <td />
            <td>{item.description}</td>
            <td />
            <td>
              <div class='price'>
                <i className={priceIconLeft} />
                <span className='alt'>-{currency.format(item.amount)}</span>
              </div>
            </td>
          </tr>
        )
      })
    }

    return null
  }

  _renderHistories () {
    const items = this.data.histories
    const priceIconLeft = this.props.isTeamUSA
      ? 'icon icon-setting-setting-list-usd'
      : 'icon icon-setting-listeuro'

    if (items && items.length > 0) {
      return items.map((item, idx) => {
        const toDate = new Date(item.toDate)

        const dateText = `${IntlUtil.convertMessage(
          `planner.planner.month${Util.getFullMonth(toDate)}`
        )} ${toDate.getFullYear()}`

        return (
          <div className='item' key={idx}>
            <span className='col month'>{dateText}</span>
            <span className='col period'>
              {item.fromDate && item.toDate
                ? `${DateUtil.getDisplayDate(
                    item.fromDate
                  )} - ${DateUtil.getDisplayDate(item.toDate)}`
                : '-'}
            </span>
            <span className='col triggerdate'>
              {item.triggerDate
                ? DateUtil.getDisplayDate(item.triggerDate)
                : '-'}
            </span>
            <span className='col date'>
              {item.status === 'Paid'
                ? DateUtil.getDisplayDate(item.paidDate)
                : item.status}
            </span>
            <span className='col invoiceno'>
              {item.invoiceNo ? item.invoiceNo : '-'}
            </span>
            <span
              className='col download'
              onClick={this._onClickDownload.bind(this, {
                historyId: item.id,
                isSubscriptionV2: item.isV2,
                invoiceNo: item.invoiceNo
              })}
            >
              <IconButton
                size='normal'
                icon='subscription-download'
                title='setting.subscription.download'
                canHover={false}
                className='subscription-download'
              />
            </span>
            <i className={priceIconLeft} />
            <span className='col price'>{currency.format(item.totalExcl)}</span>
          </div>
        )
      })
    }

    return ''
  }
}

export default SubscriptionContent
